var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M10.096 15.929v-4.858a7.685 7.685 0 017.685-7.685 7.672 7.672 0 017.686 7.686v4.858"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 18.132,
    cy: 22.585,
    r: 1.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M28.642 21.475v-5.546H6.922v5.502a7.809 7.809 0 007.809 7.809h5.959"
  }), /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M21.932 34.275l13.67-13.67L39 24.003l-13.67 13.67-4.859 1.461 1.461-4.859z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditLock);
export default __webpack_public_path__ + "static/media/editLock.c45fc68a6d3e0be6d169341ece6ce488.svg";
export { ForwardRef as ReactComponent };